import React, { useEffect, useState } from 'react';
import axiosInstance from "../../../api/api";
import { Table, Button, Form, Row, Col, Pagination, Card, Modal } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faEdit } from '@fortawesome/free-solid-svg-icons';
import ReactQuill from "react-quill";
import EditForm from "../../dashboard/DetailOption/EditFormPage";

const DetailOptionList = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [descriptionFilter, setDescriptionFilter] = useState('');
    const [valueFilter, setValueFilter] = useState('');
    const [typeFilter, setTypeFilter] = useState('');

    const [page, setPage] = useState(0);
    const [size] = useState(10);
    const [totalPages, setTotalPages] = useState(1);

    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    // Estado para edición rápida de Tooltip y Modal
    const [showRTModal, setShowRTModal] = useState(false);
    const [rtField, setRtField] = useState(null);
    const [rtItem, setRtItem] = useState(null);
    const [rtValue, setRtValue] = useState("");

    const fetchData = async () => {
        setLoading(true);
        try {
            const params = {
                page: page,
                size: size,
                sort: 'id,asc'
            };
            if (descriptionFilter) params.description = descriptionFilter;
            if (valueFilter) params.value = valueFilter;
            if (typeFilter) params.type = typeFilter;

            const response = await axiosInstance.get('/detailoption/all', { params });
            const responseData = response.data;

            if (Array.isArray(responseData)) {
                setData(responseData);
                setTotalPages(1);
            } else if (responseData && responseData.data && Array.isArray(responseData.data.content)) {
                setData(responseData.data.content);
                setTotalPages(responseData.data.totalPages || 1);
            } else if (responseData && responseData.data && Array.isArray(responseData.data)) {
                setData(responseData.data);
                setTotalPages(responseData.totalPages || 1);
            } else if (responseData && Array.isArray(responseData.content)) {
                setData(responseData.content);
                setTotalPages(responseData.totalPages || Math.ceil(responseData.totalElements / size) || 1);
            } else {
                setData([]);
                setTotalPages(1);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, size]);

    const handleSearch = (e) => {
        e.preventDefault();
        if (page === 0) {
            fetchData();
        } else {
            setPage(0);
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
        }
    };

    const handleRichTextEdit = (item, field) => {
        setRtItem(item);
        setRtField(field);
        setRtValue(item[field] || "");
        setShowRTModal(true);
    };

    const handleSaveRichText = async (e) => {
        e.preventDefault();
        const updatedItem = { ...rtItem, [rtField]: rtValue };
        try {
            await axiosInstance.post(`/detailoption/`, updatedItem);
            alert("Texto actualizado correctamente");
            setShowRTModal(false);
            fetchData();
        } catch (error) {
            console.error("Error al guardar texto enriquecido:", error);
            alert("Error al guardar los datos.");
        }
    };

    const handleEdit = (id) => {
        setSelectedId(id);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedId(null);
    };

    return (
        <Card border="light" className="table-wrapper table-responsive shadow-sm">
            <Card.Body>
                <div className="table-settings mb-4">
                    <Form onSubmit={handleSearch}>
                        <Row className="justify-content-between align-items-center">
                            <Col md={3} className="d-flex">
                                <Form.Control
                                    type="text"
                                    placeholder="Buscar por Descripción..."
                                    value={descriptionFilter}
                                    onChange={(e) => setDescriptionFilter(e.target.value)}
                                />
                            </Col>
                            <Col md={3} className="d-flex">
                                <Form.Control
                                    type="text"
                                    placeholder="Buscar por Value..."
                                    value={valueFilter}
                                    onChange={(e) => setValueFilter(e.target.value)}
                                />
                            </Col>
                            <Col md={3} className="d-flex">
                                <Form.Control
                                    type="text"
                                    placeholder="Buscar por Type..."
                                    value={typeFilter}
                                    onChange={(e) => setTypeFilter(e.target.value)}
                                />
                            </Col>
                            <Col md={2} className="d-flex">
                                <Button variant="primary" type="submit" className="w-100">
                                    Buscar
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </div>

                <Table hover className="user-table align-items-center">
                    <thead>
                        <tr>
                            <th className="border-bottom">ID</th>
                            <th className="border-bottom">Description</th>
                            <th className="border-bottom">Value</th>
                            <th className="border-bottom">Type</th>
                            <th className="border-bottom">Tooltip</th>
                            <th className="border-bottom">Modal</th>
                            <th className="border-bottom">Orden</th>
                            <th className="border-bottom">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan="6" className="text-center">Cargando...</td></tr>
                        ) : data.length === 0 ? (
                            <tr><td colSpan="6" className="text-center">No se encontraron resultados</td></tr>
                        ) : (
                            data.map(item => (
                                <tr key={item.id}>
                                    <td><span className="fw-normal">{item.id}</span></td>
                                    <td>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className="fw-normal" dangerouslySetInnerHTML={{ __html: item.description }} />
                                            <Button variant="link" size="sm" className="p-0 text-info ms-2" onClick={() => handleRichTextEdit(item, 'description')} title="Editar Descripción">
                                                <FontAwesomeIcon icon={faEdit} size="lg" />
                                            </Button>
                                        </div>
                                    </td>
                                    <td><span className="fw-normal">{item.value}</span></td>
                                    <td><span className="fw-normal">{item.type}</span></td>
                                    <td className="text-center align-middle">
                                        <Button variant="link" size="sm" className="p-0 text-info" onClick={() => handleRichTextEdit(item, 'tooltip')} title="Editar Tooltip">
                                            <FontAwesomeIcon icon={faInfoCircle} size="lg" />
                                        </Button>
                                    </td>
                                    <td className="text-center align-middle">
                                        <Button variant="primary" size="sm" onClick={() => handleRichTextEdit(item, 'modal')} title="Editar Modal">
                                            Más información
                                        </Button>
                                    </td>
                                    <td className="text-center align-middle">
                                        {item.orden}
                                    </td>
                                    <td>
                                        <Button variant="warning" size="sm" onClick={() => handleEdit(item.id)}>
                                            Editar
                                        </Button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>

                <Card.Footer className="px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
                    <Pagination className="mb-2 mb-lg-0">
                        <Pagination.Prev disabled={page === 0} onClick={() => handlePageChange(page - 1)}>
                            Anterior
                        </Pagination.Prev>
                        <Pagination.Item active>{page + 1}</Pagination.Item>
                        <Pagination.Next disabled={page >= totalPages - 1} onClick={() => handlePageChange(page + 1)}>
                            Siguiente
                        </Pagination.Next>
                    </Pagination>
                    <small className="fw-bold">
                        Mostrando página <b>{page + 1}</b> de <b>{totalPages === 0 ? 1 : totalPages}</b>
                    </small>
                </Card.Footer>
            </Card.Body>

            {/* Modal para Edición Rápida de Texto Enriquecido */}
            <Modal show={showRTModal} onHide={() => setShowRTModal(false)} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Editar {rtField === 'tooltip' ? 'Tooltip' : rtField === 'modal' ? 'Modal' : 'Descripción'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSaveRichText}>
                        <Form.Group controlId="formRT" style={{ height: '300px' }}>
                            <Form.Label>Texto Enriquecido</Form.Label>
                            <ReactQuill
                                value={rtValue}
                                onChange={setRtValue}
                                style={{ height: '220px', marginBottom: '40px' }}
                                modules={{
                                    toolbar: [
                                        ['bold', 'italic', 'underline', 'strike'],
                                        ['list', 'bullet', 'indent', '-1', '+1'],
                                        ['link', 'image', 'video'],
                                    ],
                                }}
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" className="mt-5">
                            Guardar Cambios
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            <EditForm id={selectedId} show={showModal} handleClose={handleCloseModal} onAdd={fetchData} />
        </Card>
    );
};

export default DetailOptionList;
